import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/media/videos/6-poster.jpg")